// =============================================================================
// features/sales/campaigns/CampaignsHeader.tsx — Cabeçalho de /campanhas:
// título + CTA "Nova campanha" (doc 26 §6.5, visível só com
// `sales_campaigns:manage` — Escopo do slot).
//
// O wizard `/campanhas/nova` (F35-S08) está pronto e roteado em App.tsx.
// O CTA fica visível só com a permissão de gerenciar campanhas (mesma
// decisão de features/sales/agenda/AgendaHeader.tsx para "Agendar retorno")
// e navega direto para o wizard.
// =============================================================================

import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../components/ui/Button';

export interface CampaignsHeaderProps {
  canManage: boolean;
}

export function CampaignsHeader({ canManage }: CampaignsHeaderProps): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1
          className="font-display font-bold text-ink"
          style={{
            fontSize: 'var(--text-3xl)',
            letterSpacing: '-0.045em',
            lineHeight: 1.05,
            fontVariationSettings: "'opsz' 48",
          }}
        >
          Campanhas
        </h1>
        <p className="font-sans mt-1 text-sm text-ink-3">
          O que está ativo, quanto falta trabalhar e onde há alerta.
        </p>
      </div>

      {canManage && (
        <Button variant="primary" onClick={() => navigate('/campanhas/nova')}>
          Nova campanha
        </Button>
      )}
    </div>
  );
}
